import {
  ADD_ORGANIZATION,
  ADD_ORGANIZATION_SUCCESS,
  ADD_ORGANIZATION_FAILURE,
  UPDATE_ORGANIZATION,
  UPDATE_ORGANIZATION_SUCCESS,
  UPDATE_ORGANIZATION_FAILURE,
  DELETE_ORGANIZATION,
  DELETE_ORGANIZATION_SUCCESS,
  DELETE_ORGANIZATION_FAILURE,
  GET_ORGANIZATIONS,
  GET_ORGANIZATIONS_SUCCESS,
  GET_ORGANIZATIONS_FAILURE,
  GET_PRE_ON_BOARDED_ORGANIZATIONS,
  GET_PRE_ON_BOARDED_ORGANIZATIONS_SUCCESS,
  GET_PRE_ON_BOARDED_ORGANIZATIONS_FAILURE,
  RESEND_ORG_ON_BOARD_ACTIVATION_LINK,
  RESEND_ORG_ON_BOARD_ACTIVATION_LINK_SUCCESS,
  RESEND_ORG_ON_BOARD_ACTIVATION_LINK_FAILURE,
  REGISTER_TRIAL_ACCOUNT_USER,
  REGISTER_TRIAL_ACCOUNT_USER_SUCCESS,
  REGISTER_TRIAL_ACCOUNT_USER_FAILURE,
  CLEAR_ALL_MESSAGES,
  CLEAR_ALL_MESSAGES_SUCCESS,
  CLEAR_SUCCESS_MESSAGES,
  CLEAR_SUCCESS_MESSAGES_SUCCESS,
  CLEAR_FAILURE_MESSAGES,
  CLEAR_FAILURE_MESSAGES_SUCCESS,
} from "./actionTypes";

export const addOrganization = (organization) => {
  console.log("addOrganization action, Organization:: ", organization);
  return {
    type: ADD_ORGANIZATION,
    payload: { organization },
  };
};

export const addOrganizationSuccess = (organization) => {
  console.log("addOrganizationSuccess action, Organization:: ", organization);
  return {
    type: ADD_ORGANIZATION_SUCCESS,
    payload: { organization }
  };
}

export const addOrganizationFailed = (error) => {
  console.log("addOrganizationFailed action, error:: ", error);
  return {
    type: ADD_ORGANIZATION_FAILURE,
    payload: { error },
  };
};

export const updateOrganization = (organization) => {
  console.log("updateOrganization action, Organization:: ", organization);
  return {
    type: UPDATE_ORGANIZATION,
    payload: { organization },
  };
};

export const updateOrganizationSuccess = () => {
  console.log("updateOrganizationSuccess action");
  return {
    type: UPDATE_ORGANIZATION_SUCCESS,
  };
};

export const updateOrganizationFailed = (error) => {
  console.log("updateOrganizationFailed action, error:: ", error);
  return {
    type: UPDATE_ORGANIZATION_FAILURE,
    payload: { error },
  };
};

export const deleteOrganization = (orgCode) => {
  console.log("deleteOrganization action, Organization Code:: ", orgCode);
  return {
    type: DELETE_ORGANIZATION,
    payload: { orgCode },
  };
};

export const deleteOrganizationSuccess = () => {
  console.log(
    "deleteOrganizationSuccess action");
  return {
    type: DELETE_ORGANIZATION_SUCCESS,
  };
};

export const deleteOrganizationFailed = (error) => {
  console.log("deleteOrganizationFailed action, error:: ", error);
  return {
    type: DELETE_ORGANIZATION_FAILURE,
    payload: { error },
  };
};

//TODO: change parameter 
export const getOrganizations = (organizations) => {
  console.log("getOrganizations action, Organizations:: ", organizations);
  return {
    type: GET_ORGANIZATIONS,
    payload: { organizations },
  };
};

export const getOrganizationsSuccess = (organizations) => {
  console.log("getOrganizationsSuccess action, Organizations:: ", organizations);
  return {
    type: GET_ORGANIZATIONS_SUCCESS,
    payload: { organizations },
  };
};

export const getOrganizationsFailed = (error) => {
  console.log("getOrganizationsFailed action, error:: ", error);
  return {
    type: GET_ORGANIZATIONS_FAILURE,
    payload: { error },
  };
};

export const getPreOnBoardedOrganizations = () => {
  console.log("getPreOnBoardedOrganizations action :: ");
  return {
    type: GET_PRE_ON_BOARDED_ORGANIZATIONS,
    payload: {  },
  }
}

export const getPreOnBoardedOrganizationsSuccess = (preOnBoardedOrganizations) => {
  console.log("getPreOnBoardedOrganizations action, message:: ", preOnBoardedOrganizations);
  return {
    type: GET_PRE_ON_BOARDED_ORGANIZATIONS_SUCCESS,
    payload: { preOnBoardedOrganizations },
  }
}

export const getPreOnBoardedOrganizationsFailed = (getPreOnBoardedOrganizationsError) => {
  console.log("getPreOnBoardedOrganizations action, message:: ", getPreOnBoardedOrganizationsError);
  return {
    type: GET_PRE_ON_BOARDED_ORGANIZATIONS_FAILURE,
    payload: { getPreOnBoardedOrganizationsError },
  }
}

export const resendOrgOnBoardActionLink = (token) => {
  console.log("resendOrgOnBoardActionLink action, token:: ", token);
  return {
    type: RESEND_ORG_ON_BOARD_ACTIVATION_LINK,
    payload: { token },
  }
}

export const resendOrgOnBoardActionLinkSuccess = (resendOrgOnBoardActionLinkMessage) => {
  console.log("resendOrgOnBoardActionLink action, resendOrgOnBoardActionLinkMessage:: ", resendOrgOnBoardActionLinkMessage);
  return {
    type: RESEND_ORG_ON_BOARD_ACTIVATION_LINK_SUCCESS,
    payload: { resendOrgOnBoardActionLinkMessage },
  }
}

export const resendOrgOnBoardActionLinkFailure = (resendOrgOnBoardActionLinkError) => {
  console.log("resendOrgOnBoardActionLink action, resendOrgOnBoardActionLinkError:: ", resendOrgOnBoardActionLinkError);
  return {
    type: RESEND_ORG_ON_BOARD_ACTIVATION_LINK_FAILURE,
    payload: { resendOrgOnBoardActionLinkError },
  }
}

export const registerTrialAccountUser = (user) => {
  console.log("registerTrialAccountUser action, User:: ", user);
  return {
    type: REGISTER_TRIAL_ACCOUNT_USER,
    payload: { user },
  };
};

export const registerTrialAccountUserSuccess = (user) => {
  console.log("registerTrialAccountUserSuccess action");
  return {
    type: REGISTER_TRIAL_ACCOUNT_USER_SUCCESS,
    payload: { user },
  };
};

export const registerTrialAccountUserFailure = (error) => {
  console.log("registerTrialAccountUserFailure action, error:: ", error);
  return {
    type: REGISTER_TRIAL_ACCOUNT_USER_FAILURE,
    payload: { error },
  };
};

export const clearAllMessages = () => {
  return {
    type: CLEAR_ALL_MESSAGES,
    payload: {},
  };
};

export const clearAllMessagesSuccess = () => {
  return {
    type: CLEAR_ALL_MESSAGES_SUCCESS,
    payload: {},
  };
};

export const clearSuccessMessages = () => {
  return {
    type: CLEAR_SUCCESS_MESSAGES,
    payload: {},
  };
};

export const clearSuccessMessagesSuccess = () => {
  return {
    type: CLEAR_SUCCESS_MESSAGES_SUCCESS,
    payload: {},
  };
};

export const clearFailureMessages = () => {
  return {
    type: CLEAR_FAILURE_MESSAGES,
    payload: {},
  };
};

export const clearFailureMessagesSuccess = () => {
  return {
    type: CLEAR_FAILURE_MESSAGES_SUCCESS,
    payload: {},
  };
};